import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const RewardAllocationList = Loadable(lazy(() => import('./RewardAllocationList')));
const AddRewardAllocation = Loadable(lazy(() => import('./AddRewardAllocation')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const RewardAllocationRoutes = [
  {
    path: '/reward/allocation/list',
    element: (
      //<PrivateRoute pageUrl="RewardAllocationMaster" requiredFunc="VIE">
        <RewardAllocationList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/reward/allocation/manage',
    element: (
      <PrivateRoute pageUrl="RewardAllocationMaster" requiredFunc="ADD">
        <AddRewardAllocation />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default RewardAllocationRoutes;
